const actions = {
  MYMENU_ORDERS_REQUEST: "MYMENU_ORDERS_REQUEST",
  MYMENU_ORDERS_SUCCESS: "MYMENU_ORDERS_SUCCESS",

  myMenuOrders: (startDate, endDate, selectedRestaurant) => {
    return (dispatch) => {
      dispatch({
        type: actions.MYMENU_ORDERS_REQUEST,
        startDate,
        endDate,
        selectedRestaurant,
      });
    };
  },
};
export default actions;
